import { UI, VStack } from '@genial/components';
import React from 'react';

export const SubscriptionEmptyList: React.FC = () => {
  return (
    <VStack py="stack.huge">
      <UI.ErrorBoundary
        errorIconOrIllustration="NotEmptyIllustration"
        errorTitle="Nenhum evento disponível"
        errorMessage="No momento, não há eventos disponíveis para subscrição."
      />
    </VStack>
  );
};
